
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import paScenariosQuery from '~/apollo/queries/product/personalAccidentScenario.gql';
import paTooltips from '~/apollo/queries/product/tooltips/personalAccidentTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productInsuranceNameMixins],

  data() {
    return {
      paScenarios: null,
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    paScenarios: {
      query: gql`
        ${paScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          locale: this.currentLocale,
        };
      },
  },

    paTooltips: {
      query: paTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    simpleItems() {
      if (this.paScenarios?.data[0]) {
        // const decoderCTALink = '';
        let promotionPrices = Array;
        promotionPrices = [];

        const item = this.paScenarios.data[0];
        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        let decoderCTALink = '';
        let decoderCTAText = '';
        let hide = Boolean;
        hide = false;
        let noPopup = Boolean;
        noPopup = false;
        let mainCTA = this.getDecoderCTA(item, decoderCTALink);


        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.pa_plans.data[0].attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.pa_plans.data[0].attributes.product_promotions.data;
        }

        if(promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          if (!promotion) {
            promotion = null;
          } else {
            if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');

                  mainCTA = this.getDecoderCTA(item, decoderCTALink)
              }
            const discounts = promotion.attributes.DiscountPercentage;
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (discounts) {
              // calculate promotion price for annual premium
              const annualPremium = item.attributes.pa_premiums.data[0].attributes.annual_premium;

              if (discounts.Year1 === 0) {
                promotionPrices[0] = null;
              } else {
                const calculatedPrice = (annualPremium * (100 - discounts.Year1)) / 100;
                promotionPrices[0] = parseInt(calculatedPrice.toFixed(0));
              }
            }

            const translation = promotion.attributes.product_promotion_translations?.data[0];
            hide = translation.attributes?.HideBanner;
            noPopup = translation?.attributes?.NoPopup??false;
          }
        }

        const filteredTranslations = this.getFilteredTranslations(item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          scenario_code: item.attributes.scenario_code,
          plan_code: item.attributes.plan_code,
          annual_premium: item.attributes.pa_premiums.data[0].attributes.annual_premium,
          overall_score: item.attributes.overall_score,
          death_dismemberment_score: item.attributes.death_dismemberment_score,
          medical_score: item.attributes.medical_score,
          physio_score: item.attributes.physio_score,
          bonesetter_score: item.attributes.bonesetter_score,
          sum_assured: item.attributes.sum_assured,
          overall_star: item.attributes?.overall_star,
          is_flexible_sa: item.attributes.pa_plans.data[0].attributes.flexible_sa,
          show_cta: item.attributes.show_cta,

          // PA_plan_translation
          plan_name:
            item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0]
              .attributes.name,
          min_issue_age:
            item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0]
              .attributes.issue_age_from_display,
          max_issue_age:
            item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0]
              .attributes.issue_age_to_display,
          max_cover_age:
            item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0]
              .attributes.max_cover_age_display,

          // insurer
          insurer_name_first:
            item.attributes.pa_plans.data[0].attributes.product.data.attributes
              .insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.pa_plans.data[0].attributes.product.data.attributes
              .insurance_company.data.attributes.logo,
          insurer_code:
            item.attributes.pa_plans.data[0].attributes.product.data.attributes
              .insurance_company.data.attributes.code,

          // pa_coverage_accidents
          pa_coverage_accidents:
            item.attributes.pa_coverage_accidents.data,
          // pa_coverage_physios
          pa_coverage_physios:
            item.attributes.pa_coverage_physios.data,
          // pa_coverage_medicals
          pa_coverage_medicals:
            item.attributes.pa_coverage_medicals.data,
          // pa_coverage_medical_terms
          pa_coverage_medical_terms:
            item.attributes.pa_coverage_medical_terms.data,
          // pa_coverage_bonesetters
          pa_coverage_bonesetters:
            item.attributes.pa_coverage_bonesetters.data,

          product_promotion: promotion,
          promotion_prices: promotionPrices,
          promotion_last_call: promotion_last_call,

          // discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
          // cta_button_link: CTAButtonLink,
          // cta_button_text: CTAButtonText,

          main_cta: mainCTA,

          scenarioID: item.id,
          hide,
          noPopup,
        };
      }
      return null;
    },
    product() {
      if (!this.simpleItems) return null;
      const item = this.simpleItems;
      const featureArray = [
          {
            text: '$' + this.$formatPrice(parseInt(item.sum_assured)) + ' ' + this.$t('products.personal_accident.pd_sum_assured'),
            type: 'sum_assured'
          },
      ]
      if (item.is_flexible_sa) {
          featureArray.push(
            {
            text: this.$t('products.personal_accident.pd_flexible_sa'),
            type: 'optional_sum_assured'
            }
          )
      }
      return {
        highlightSection: {
          scenarioId: item.scenarioID,
          showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes?.url,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            // score: this.simpleItems.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(item.overall_score),
            description: this.$t('products.personal_accident.pd_overall_score'),
            toolTipHtml: this.getTooltipContentByKey('pa_overallScore'),
          },
          features: featureArray,
          keyItems: [
            {
              value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_death_dismember_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_deathDismembermentScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.medical_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_medical_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_medicalScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.physio_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_physio_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_physioScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.bonesetter_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_chinese_med'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_bonesetterScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: item?.promotion_prices[0]
                ? parseInt(item?.promotion_prices[0]).toLocaleString('en-US')
                : item?.annual_premium
                ? this.$formatPrice(item?.annual_premium)
                : '',
              key: this.$t('products.personal_accident.pd_firstYearPremium'),
              topSubText: 'HKD',
              toolTipHtml: this.getTooltipContentByKey('pa_adult'),
              symbolValue: '',
              originalValue: item?.promotion_prices[0]
                ? item?.annual_premium
                  ? this.$formatPrice(item?.annual_premium)
                  : ''
                : '',
            }
        ],
          mainButtonCTA: this.simpleItems.main_cta,
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.personal_accident.pd_overview'),
              keyValues: [
                {
                  key: this.$t('products.personal_accident.pd_overall_score'),
                  value: this.$formatScore(item.overall_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_death_dismember_score'),
                  value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.personal_accident.pd_accident_death_score'),
                      value: this.$formatScore(this.getAccidentValue("accidental_death_score")) + ' / 10',
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_score'),
                      value: this.$formatScore(this.getAccidentValue("dismemberment_score")) + ' / 10',
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                {
                  key: this.$t('products.personal_accident.pd_medical_score'),
                  value: this.$formatScore(item.medical_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_physio_score'),
                  value: this.$formatScore(item.physio_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_chinese_med'),
                  value: this.$formatScore(item.bonesetter_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_sum_assured'),
                  value: 'HKD' + ' ' + this.$formatPrice(parseInt(item.sum_assured)),
                  keyToolTipHtml: this.getTooltipContentByKey('pa_sum_assured'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_firstYearPremium'),
                  value: 'HKD' + ' ' + (item?.promotion_prices[0]
                  ? parseInt(item?.promotion_prices[0]).toLocaleString('en-US')
                  : item?.annual_premium
                  ? this.$formatPrice(item?.annual_premium)
                  : ''),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                  originalValue: item?.promotion_prices[0]
                  ? item?.annual_premium
                    ? 'HKD' + ' ' + this.$formatPrice(item?.annual_premium)
                    : ''
                  : '',
                },
                {
                  key: this.$t('products.personal_accident.pd_min_issue_age'),
                  value: item?.min_issue_age,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_max_issue_age'),
                  value: item?.max_issue_age,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_max_cover_age'),
                  value: item?.max_cover_age,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },


                // {
                //   key: this.$t('products.home.hm_llMaximumProtection'),
                //   value: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1010').value,
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
                // {
                //   key: this.$t('products.home.hm_paMaximumProtection'),
                //   value: this.$formatSymbol(
                //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1010').value
                //   ),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
                // {
                //   key: this.$t('products.home.hm_annualPremium'),
                //   value: this.simpleItems.promotion_prices[0]
                //     ? this.$formatPrice(this.simpleItems.promotion_prices[0])
                //     : this.$formatPrice(this.simpleItems.annual_premium),
                //   originalValue: this.simpleItems.promotion_prices[0]
                //     ? this.$formatPrice(this.simpleItems.annual_premium)
                //     : '',
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
                // {
                //   key: this.$t('products.home.hm_propertyAgeMax'),
                //   value: this.$formatPrice(this.simpleItems.building_age_max),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
                // {
                //   key: this.$t('products.home.hm_propertyType'),
                //   value: this.getMultiplePropertyType(this.simpleItems.multiple_property_type),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.personal_accident.pd_death_dismember'),
              keyValues: [
                {
                  key: this.$t('products.personal_accident.pd_death_dismember_score'),
                  value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.personal_accident.pd_accident_death_score'),
                      value: this.$formatScore(this.getAccidentValue("accidental_death_score")) + ' / 10',
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_score'),
                      value: this.$formatScore(this.getAccidentValue("dismemberment_score")) + ' / 10',
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },



                {
                  key: this.$t('products.personal_accident.pd_death_coverage_sum_assured'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                  {
                      key: this.$t('products.personal_accident.pd_death_benefit'),
                      value: this.$formatPercentageDP(this.getAccidentValue("accidental_death", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                {
                  key: this.$t('products.personal_accident.pd_dismemberment_coverage_sum_assured'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_two_limbs'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_two_limbs", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_one_limb'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_one_limb", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_both_eyes'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_both_eyes", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_one_eye'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_one_eye", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_both_ears'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_both_ears", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_one_ear'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_one_ear", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_speech'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_speech", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_all_toes'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_all_toes", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_thumbs_fingers_main'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_thumbs_fingers_main", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_dismemberment_loss_thumbs_fingers_another'),
                      value: this.$formatPercentageDP(this.getAccidentValue("dismemberment_loss_thumbs_fingers_another", true), 0),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
              ],
            },
            {
              id: 2,
              sectionTitle: this.$t('products.personal_accident.pd_medical'),
              keyValues: [
                  {
                    key: this.$t('products.personal_accident.pd_medical_score'),
                    value: this.$formatScore(item.medical_score) + ' / 10',
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.personal_accident.pd_medical_expenses'),
                    value: this.getMedicalValue("medical_expenses") < 1?
                    this.getMedicalTermValue():
                    'HKD' + ' ' + this.$formatPrice(this.getMedicalValue("medical_expenses")) + ' ' + this.getMedicalTermValue()
                    ,
                    keyToolTipHtml: '',
                    expandableKeyValues: [],
                  },
                  {
                    key: this.$t('products.personal_accident.pd_medical_estimated_coverage'),
                    value: '',
                    keyToolTipHtml: '',
                    expandableKeyValues: [
                      {
                        key: this.$t('products.personal_accident.pd_medical_case_1_recovery_rate'),
                        value: this.$formatPercentageDP(this.getMedicalValue("medical_case_1_recovery_rate", true), 0),
                        keyToolTipHtml: '',
                        expandableKeyValues: [],
                      },
                      {
                        key: this.$t('products.personal_accident.pd_medical_case_2_recovery_rate'),
                        value: this.$formatPercentageDP(this.getMedicalValue("medical_case_2_recovery_rate", true), 0),
                        keyToolTipHtml: '',
                        expandableKeyValues: [],
                      },
                      {
                        key: this.$t('products.personal_accident.pd_medical_case_3_recovery_rate'),
                        value: this.$formatPercentageDP(this.getMedicalValue("medical_case_3_recovery_rate", true), 0),
                        keyToolTipHtml: '',
                        expandableKeyValues: [],
                      },
                      {
                        key: this.$t('products.personal_accident.pd_medical_case_4_recovery_rate'),
                        value: this.$formatPercentageDP(this.getMedicalValue("medical_case_4_recovery_rate", true), 0),
                        keyToolTipHtml: '',
                        expandableKeyValues: [],
                      },
                    ],
                  },
              ],
            },
            {
              id: 3,
              sectionTitle: this.$t('products.personal_accident.pd_physio_chinese'),
              keyValues: [
                {
                  key: this.$t('products.personal_accident.pd_physio_score'),
                  value: this.$formatScore(item.physio_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('hm_personalAccidentScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_physio_follow_up'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.personal_accident.pd_physio_limit_per_policy_year'),
                      value: this.getPhysioValue("physio_limit_per_policy_year") < 1?
                      this.getPhysioValue("physio_limit_per_policy_year") == 0? this.$t('products.personal_accident.pd_na') : this.$t('products.personal_accident.pd_not_specified')
                      :
                      this.getPhysioValue("physio_limit_per_policy_year")
                      ,
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_physio_limit_per_visit'),
                      value: this.getPhysioValue("physio_limit_per_visit") < 1?
                      this.getPhysioValue("physio_limit_per_visit") == 0? this.$t('products.personal_accident.pd_na') : this.$t('products.personal_accident.pd_not_specified')
                      :
                      'HKD' + ' ' + this.$formatPrice(this.getPhysioValue("physio_limit_per_visit")),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_physio_total_limit'),
                      value: this.getPhysioValue("physio_total_limit") == 0?
                      this.$t('products.personal_accident.pd_na') :
                      'HKD' + ' ' + this.$formatPrice(this.getPhysioValue("physio_total_limit")),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                {
                  key: this.$t('products.personal_accident.pd_chinese_med'),
                  value: this.$formatScore(item.bonesetter_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.personal_accident.pd_chinese_medical_follow_up'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.$t('products.personal_accident.pd_bonesetter_limit_per_policy_year'),
                      value: this.getBonesetterValue("bonesetter_limit_per_policy_year") < 1?
                      this.getBonesetterValue("bonesetter_limit_per_policy_year") == 0? this.$t('products.personal_accident.pd_na') : this.$t('products.personal_accident.pd_not_specified')
                      :
                        this.getBonesetterValue("bonesetter_limit_per_policy_year"),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_bonesetter_limit_per_visit'),
                      value: this.getBonesetterValue("bonesetter_limit_per_visit") < 1?
                      this.getBonesetterValue("bonesetter_limit_per_visit") == 0? this.$t('products.personal_accident.pd_na') : this.$t('products.personal_accident.pd_not_specified')
                      :
                        'HKD' + ' ' + this.$formatPrice(this.getBonesetterValue("bonesetter_limit_per_visit")),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.$t('products.personal_accident.pd_bonesetter_total_limit'),
                      value: this.getBonesetterValue("bonesetter_total_limit") == 0?
                      this.$t('products.personal_accident.pd_na'):
                      'HKD' + ' ' + this.$formatPrice(this.getBonesetterValue("bonesetter_total_limit")),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
              ],
            },
          ],
          promotion: {
            category:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionCategory,
            title:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionTitle,
            ctaButtonLink:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonLink,
            ctaButtonText:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonText,
            promotionId: this.simpleItems.product_promotion?.id,
            scenarioId: this.simpleItems.scenarioId,
            hide: this.simpleItems.hide,
            noPopup: this.simpleItems.noPopup,
            lastCall: item.promotion_last_call

          },
        },
        // promotion: {
        //   category:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.PromotionCategory,
        //   title:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.PromotionTitle,
        //   ctaButtonLink:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.CTAButtonLink,
        //   ctaButtonText:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.CTAButtonText,
        //   promotionId: this.simpleItems.product_promotion?.id,
        //   scenarioId: this.simpleItems.scenarioId,
        // },
      };
    },
  },

  methods: {
    getAccidentValue(code, isPercentage = false) {
      if (isPercentage) {
        return this.simpleItems.pa_coverage_accidents.find(item => item.attributes.code === code).attributes.value;
      }
      return parseInt((this.simpleItems.pa_coverage_accidents.find(item => item.attributes.code === code)).attributes.value);
    },
    getPhysioValue(code, isPercentage = false) {
      if (isPercentage) {
        return this.simpleItems.pa_coverage_physios.find(item => item.attributes.code === code).attributes.value;
      }
      return parseInt((this.simpleItems.pa_coverage_physios.find(item => item.attributes.code === code)).attributes.value);
    },
    getMedicalValue(code, isPercentage = false) {
      if (isPercentage) {
        return this.simpleItems.pa_coverage_medicals.find(item => item.attributes.code === code).attributes.value;
      }
      return parseInt((this.simpleItems.pa_coverage_medicals.find(item => item.attributes.code === code)).attributes.value);
    },
    getMedicalTermValue() {
      return this.simpleItems.pa_coverage_medical_terms[0].attributes.value;
    },
    getBonesetterValue(code, isPercentage = false) {
      if (isPercentage) {
        return this.simpleItems.pa_coverage_bonesetters.find(item => item.attributes.code === code).attributes.value;
      }
      return parseInt((this.simpleItems.pa_coverage_bonesetters.find(item => item.attributes.code === code)).attributes.value);
    },

    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.personal_accident.pd_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.pa_plans.data.attributes?.saleable;
      const productWebsite =
        item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes?.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    getTooltipContentByKey(mKey) {
      return this.paTooltips?.PersonalAccident?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

  },
};
